<template>
  <div :class="classes()">
    <Container>
      <Widget>
        <Headline :heading="1" size="m" isViewHeadline>
          {{ $t('profile.legal.form.privacyStatement') }}
        </Headline>

        <div v-if="content" v-html="content" />

        <div v-else>
          <Copy v-if="error" color="supportDanger" size="l" centered>
            {{ $t('intro.error') }}
          </Copy>
          <Spinner insideWidget />
        </div>
      </Widget>
    </Container>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Container from '@/objects/Container';
import Spinner from '@/objects/Spinner';
import Widget from '@/objects/Widget';
import Vue from 'vue';
import { ROUTE_API_GET_PRIVACY_STATEMENT } from '@/constants/apiRoutes';
import Copy from '@/objects/Copy/Copy';

export default {
  name: 'PrivacyStatement',
  title: 'Datenschutz',
  components: { Copy, Container, Headline, Spinner, Widget },
  props: {},
  created() {
    this.getPrivacy();
  },

  data() {
    return {
      content: '',
      error: false,
      el: 'v-privacyStatement',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    getPrivacy() {
      Vue.axios
        .get(ROUTE_API_GET_PRIVACY_STATEMENT)
        .then((response) => {
          this.content = response.data.privacyStatement;
        })
        .catch(() => {
          this.error = true;
        });
    },
  },
};
</script>
